module.exports = __webpack_public_path__ + "static/FAQ-banner2-498f4fd97fbb27a832e1c829e7d58150.jpg";